import {
  MapIndicator,
  LotType,
  CalendarDatesMapIndices,
  WeatherDataObject,
  DateState,
  CalendarDateIndex,
  SatelliteProviders,
  IndicatorEmergenceDays,
} from 'types'
import { AvailableSatellites } from 'features/MainRouter/features/Map/types'

import { LeftBar, RightBar } from './components'

interface Props {
  grainHumidityHasNotEmergenceDaysActivation: boolean
  onHandleMapIndexChange: (mapIndex: MapIndicator) => void
  selectedMapIndex: MapIndicator
  isWaterAvailable: boolean
  isGrainHumidityAvailable: boolean
  isWeedsAvailable: boolean
  isEmergenceAvailable: boolean
  onHandleCalendarDateChange: (date?: string) => void
  setDates: React.Dispatch<React.SetStateAction<DateState>>
  calendarDatesIndices: CalendarDatesMapIndices
  selectedCalendarDate?: string
  weatherDataForAllLots: WeatherDataObject
  selectedLots: LotType[]
  emergenceDaysActivationIndices: IndicatorEmergenceDays
  isShowDamsModeSelected: boolean
  damsCalendar: CalendarDateIndex[]
  weatherDataForDams: WeatherDataObject
  onHandleSatelliteChange: (value: SatelliteProviders) => void
  selectedSatellite: SatelliteProviders
  availableSatellites: AvailableSatellites
  selectedCropId?: number
}
export const TopBars: React.FC<Props> = ({
  calendarDatesIndices,
  grainHumidityHasNotEmergenceDaysActivation,
  isGrainHumidityAvailable,
  isWaterAvailable,
  isWeedsAvailable,
  isEmergenceAvailable,
  selectedMapIndex,
  onHandleCalendarDateChange,
  setDates,
  selectedCalendarDate,
  onHandleMapIndexChange,
  weatherDataForAllLots,
  selectedLots,
  emergenceDaysActivationIndices,
  isShowDamsModeSelected,
  damsCalendar,
  weatherDataForDams,
  onHandleSatelliteChange,
  selectedSatellite,
  availableSatellites,
  selectedCropId,
}) => {
  return (
    <>
      <LeftBar
        grainHumidityHasNotEmergenceDaysActivation={grainHumidityHasNotEmergenceDaysActivation}
        onHandleMapIndexChange={onHandleMapIndexChange}
        selectedMapIndex={selectedMapIndex}
        isWaterAvailable={isWaterAvailable}
        isGrainHumidityAvailable={isGrainHumidityAvailable}
        isWeedsAvailable={isWeedsAvailable}
        isEmergenceAvailable={isEmergenceAvailable}
        onHandleCalendarDateChange={onHandleCalendarDateChange}
        setDates={setDates}
        calendarDatesIndices={calendarDatesIndices}
        selectedCalendarDate={selectedCalendarDate}
        isShowDamsModeSelected={isShowDamsModeSelected}
        damsCalendar={damsCalendar}
        onHandleSatelliteChange={onHandleSatelliteChange}
        selectedSatellite={selectedSatellite}
        availableSatellites={availableSatellites}
      />
      <RightBar
        weatherDataForAllLots={weatherDataForAllLots}
        selectedCalendarDate={selectedCalendarDate}
        selectedLots={selectedLots}
        emergenceDaysActivationIndices={emergenceDaysActivationIndices}
        selectedMapIndex={selectedMapIndex}
        isShowDamsModeSelected={isShowDamsModeSelected}
        weatherDataForDams={weatherDataForDams}
        selectedCropId={selectedCropId}
      />
    </>
  )
}
